import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { getCommunityToDisplay } from '../core/communities';
import { useAuth } from './AuthProvider';

const CurrentCommunityContext = createContext({
	currentCommunityId: null,
	currentCommunity: null,
	isLoading: false,
	setCurrentCommunityId: (_id) => {},
	setCurrentCommunity: (community) => {},
});

export const useCurrentCommunity = () => useContext(CurrentCommunityContext);



export const CurrentCommunityProvider = ({ children }) => {
	const { isAuthenticated } = useAuth();
	const [currentCommunityId, setCurrentCommunityId] = useState(null);
	const [currentCommunity, setCurrentCommunity] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		let isCancelled = false;
		const fetchDetails = async (id) => {
			if (!id) {
				setCurrentCommunity(null);
				return;
			}
			// Avoid secured call if not authenticated (prevents reload loop)
			// if (!isAuthenticated) {
			// 	setCurrentCommunity(null);
			// 	return;
			// }
			setIsLoading(true);
			const data = await getCommunityToDisplay(id);
            // console.log("data::::::::;", data);
			if (!isCancelled) {
				if (data && !(data instanceof Error)) {
					const details = data?.community || data?.data || data || null;
					setCurrentCommunity(details);
				} else {
					setCurrentCommunity(null);
				}
				setIsLoading(false);
			}
		};
		fetchDetails(currentCommunityId);
		return () => {
            // console.log("current community", currentCommunity);
			isCancelled = true;
		};
	}, [currentCommunityId, isAuthenticated]);

	const value = useMemo(() => ({
		currentCommunityId,
		currentCommunity,
		isLoading,
		setCurrentCommunityId,
        setCurrentCommunity,
	}), [currentCommunityId, currentCommunity, isLoading]);

	return (
		<CurrentCommunityContext.Provider value={value}>
			{children}
		</CurrentCommunityContext.Provider>
	);
};

export const loadFirstCommunity = async (id) => {
    const community = await getCommunityToDisplay(id);
    if(CurrentCommunityProvider.setCurrentCommunity) {
        CurrentCommunityProvider.setCurrentCommunity(community);
    }
}
